import { styled } from 'twin.macro';

const MarkdownBreak = styled.br``;

export default MarkdownBreak;
